import React from 'react';

export default class TeamForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                team: "",
                id: '',
                created: '',
                league_id:0,
                league: '',
                before_league_id: 0
            }
        };
    }

    componentWillMount(){
        let st = {...this.props.selected}
        st.before_league_id = st.league_id;
        this.setState({selected: st});
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    render(){
        return(
            <div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Nombre</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="text" autoFocus onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Equipo" value={this.state.selected.team} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.team = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Liga</label>
                    </div>
                    <div className="field-body">
                        <select
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            className="input"
                            onChange={(e) => {
                                let state = {...this.state};
                                let index = e.currentTarget.selectedIndex -1;
                                state.selected.league_id = this.props.leagues[index].id;
                                state.selected.league = this.props.leagues[index].name;
                            }}
                        >
                            <option disabled={true} selected={true}>Seleccionar...</option>
                            {this.props.leagues.map(l => {
                                return (
                                    <option key={l.id} selected={l.id==this.state.selected.league_id ? "selected" :"" }>
                                        {l.name +" -- "+l.tournament_name}
                                    </option>
                                )
                            })}

                        </select>
                    </div>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button className="button is-success" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/team/form.js